// removed by extract-text-webpack-plugin
module.exports = {"styled":"Markdown__styled--3EgiQ","styledBig":"Markdown__styledBig--F08g4","heading":"Markdown__heading--1nJtT","link":"Markdown__link--16GsZ","linkButton":"Markdown__linkButton--1QQAl","link-login":"Markdown__link-login--3iBzN","root":"Markdown__root--3eUvF","bodyStyle":"Markdown__bodyStyle--MMKM6","invalidHrefMapping":"Markdown__invalidHrefMapping--3Rojm"};


//////////////////
// WEBPACK FOOTER
// ./src/client/src/components/Markdown.scss
// module id = 338
// module chunks = 0